import { selectCurriculumKey } from '@store/curriculum/curriculumSelectors';
import { setCollapseSectionsPreferences } from '@store/userAndSchool/usersAndSchoolState';
import { CUSTOMTYPES } from '@utils/curriculumHelper';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from './typedHooks';

const useExpandSection = () => {
  const dispatch = useDispatch();
  const curriculumKey = useTypedSelector(selectCurriculumKey);

  return (element) => {
    if (!element.collapsed) return;
    if (element.type === CUSTOMTYPES.section) {
      dispatch(
        setCollapseSectionsPreferences({
          curriculumKey,
          sectionKey: element.key,
          collapsed: false,
        }),
      );
    }
  };
};

export default useExpandSection;
